<template>
  <div class="my-title-box">
    <div class="title-line"></div>
    <div class="title-font">{{name}}</div>
    <div class="title-bottom-line">
      <img src="../../../assets/img/title/bottom-line.png" alt="">
    </div>
    <slot></slot>
  </div>
</template>
<script>
// <Title1></Title1>
export default {
  name: 'Title1',
  mixins: [],
  extends: {},
  props: {
    name: {
      type: String
    }
  },
  data () {
    return {}
  },
  computed: {},
  components: {},
  filter: {},
  watch: {},
  methods: {},
  created () {
  },
  mounted () {}
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
// @media  screen and (min-width:1218px){}
// @media  screen and (max-width:1217px){}
// @media  screen and (max-width:992px){}

.my-title-box{
    text-indent: 10px;
    width: 100%;
    margin: 0 auto;
    height:36px;
    position: relative;
    >div{
        position: absolute;
    }
    .title-line{
        top: 50%;
        left: 0;
        width:3px;
        height:20px;
        background:rgba(64,158,233,1);
        margin-top: -10px;
    }
    .title-font{
        top: 50%;
        height:20px;
        line-height: 20px;
        font-size:18px;
        font-weight:400;
        color:rgba(51,51,51,1);
        margin-top: -10px;
        left: 13px;
    }
    .title-bottom-line{
        width: 100%;
        height: 2px;
        bottom: 0px;
        left: 0;
        img{
            float: left;
            width: 100%;
            height: 100%;
        }
    }
}
</style>
